import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import moment from 'moment';
import TKTable from './TKTable';
import { IStore } from 'redux/store';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { vesselSelectors } from 'redux/app/vessel';
import { commonUtils } from 'redux/_common';

type OwnProps = {
	vesselId: string;
    selectedDate?: string;
};
type GMDSSCoverPageProps = PropsFromRedux & OwnProps;
function GMDSSCoverPage(props: GMDSSCoverPageProps) {
    const { vesselInfo, globalSettings, listOfPersonnels, selectedDate } =
        props;
    const gmdssData = {
        part1: {
            nameOfShip: vesselInfo?.vesselName,
            callSign: vesselInfo?.callSign,
            mmsi: vesselInfo?.mmsiNumber,
            imoNo: vesselInfo?.imoNumber,
            officialNo: globalSettings?.gmddsRadioLogSectionA?.officialNo, 
            grossTonnage: vesselInfo?.tonnage?.grossTonnage,
            dateOfExpiryOfSafetyRadioCertificate:
                globalSettings?.gmddsRadioLogSectionA
                    ?.dateOfExpiryOfShipRadioCertificate,
            portOfRegistry: vesselInfo?.portOfRegistry,
            certifiedSeaAreas:
                globalSettings?.gmddsRadioLogSectionA?.certifiedSeaAreaForShip,
            duplicationOfEquipment:
                globalSettings?.methodsOfRadioFacilities
                    ?.isDuplicationOfEquipment,
            shoreBasedMaintenance:
                globalSettings?.methodsOfRadioFacilities
                    ?.isShoreBasedMaintainance,
            atSeaMaintenanceCapability:
                globalSettings?.methodsOfRadioFacilities
                    ?.isAtSeaMaintainanceCapability,
            detailsOfServiceCompany: {
                name: globalSettings?.methodsOfRadioFacilities
                    ?.nameOfServiceCompany,
                address:
                    globalSettings?.methodsOfRadioFacilities
                        ?.addressOfServiceCompany,
            },
            detailsOfOwnerCompany: {
                name: globalSettings?.methodsOfRadioFacilities
                    ?.nameOfShipOwnerOrManager,
                address:
                    globalSettings?.methodsOfRadioFacilities
                        ?.addressOfShipOwnerOrManager,
            },
        },
    };

    const { part1 } = gmdssData;
    const {
        nameOfShip,
        imoNo,
        grossTonnage,
        callSign,
        mmsi,
        officialNo,
        dateOfExpiryOfSafetyRadioCertificate,
        atSeaMaintenanceCapability,
        detailsOfOwnerCompany,
        detailsOfServiceCompany,
        duplicationOfEquipment,
        portOfRegistry,
        certifiedSeaAreas,
        shoreBasedMaintenance,
    } = part1;

    return (
        <div className="text-base">
            {/* First page */}
            <div className="flex flex-col justify-between py-4 px-8 mb-2 print-page-break">
                <div className="font-medium text-center text-xl my-24 mx-0">
                    <h2 className="uppercase text-2xl">GMDSS Radio Logbook</h2>
                </div>
                <div className="flex justify-center mt-8 mb-32">
                    <div className="w-2/3 mt-2.5">
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Name of ship:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0">
                                {nameOfShip}
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">IMO Number:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0">
                                {imoNo}
                            </p>
                        </div>

                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">
                                Gross tonnage:
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0">
                                {grossTonnage || ''}
                            </p>
                        </div>
                        <div
                            className="flex justify-between items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <div
                                style={{ width: '54%' }}
                                className="flex items-center  mb-2"
                            >
                                <p className="mr-2 min-w-fit">Period from :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 text-sm">
                                    {selectedDate &&
                                        moment(selectedDate).format(
                                            'DD-MM-yyyy'
                                        )}{' '}
                                </p>
                            </div>
                            <div
                                style={{ width: '45%' }}
                                className="flex items-center mb-2"
                            >
                                <p className="mr-2 min-w-fit">to :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 text-sm">
                                    {selectedDate &&
                                        moment(selectedDate).format(
                                            'DD-MM-yyyy'
                                        )}
                                </p>
                            </div>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Working language of the ship:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                English
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {/* Second page */}
            <div className="flex flex-col justify-between py-4 pt-0 px-16 mb-2 text-left  print-page-break">
                <ol className="list-decimal ml-4 marker:font-medium marker:text-lg">
                    <li className="mb-6">
                        <b className="uppercase text-lg inline-block mb-2 print:mt-6">
                            Introduction
                        </b>
                        <p className="mb-4">
                            In accordance with Regulation 17 of Chapter IV of
                            the International Convention for the Safety of Life
                            at Sea, 1974, as amended (SOLAS), a record shall be
                            kept to the satisfaction of the Administration and
                            as required by the radio regulations of all
                            incidents connected with the radio communication
                            service which appear to be of importance to safety
                            of life at sea.
                        </p>
                        <p className="mb-4">
                            The radio log shall be kept at a place convenient to
                            the radio installation and shall be available for
                            inspection by any person authorized by the
                            Administration or persons authorised by another
                            Administration.
                        </p>
                    </li>
                    <li className="mb-6">
                        <b className="text-lg">
                            INSTRUCTIONS FOR COMPLETION OF THE RADIO LOG
                        </b>
                        <p className="my-4">
                            This log is divided in to four Parts. Please read
                            the instructions below before completing each Part.
                        </p>
                        <p className="mb-4">
                            The Master should inspect each page of the log on a
                            daily basis and countersign at the bottom of the
                            page on completion of each page.
                        </p>
                        <p className="mb-4">
                            The Radio Log should be kept on board for a period
                            of 12 months after completion of the last entry.
                        </p>
                        <div className="mb-4">
                            <b className="mt-6">Part I</b>
                            <ol className="list-disc ml-4">
                                <li className="ml-4">
                                    Enter all of the required particulars of the
                                    ship and details of radio certification.
                                </li>
                                <li className="ml-4">
                                    Enter the methods of ensuring the
                                    maintenance of the radio equipment.
                                </li>
                                <li className="ml-4">
                                    Enter the name and address of the
                                    owners/managers/operating agent (whichever
                                    applies).
                                </li>
                            </ol>
                        </div>
                        <div className="mb-4">
                            <b>Part II</b>
                            <ol className="list-disc ml-4">
                                <li className="ml-4">
                                    Enter the details of the qualified radio
                                    operators on board and their radio
                                    certificate details.
                                </li>
                            </ol>
                        </div>
                        <div className="mb-4">
                            <b>Part III</b>
                            <ol className="list-disc ml-4">
                                <li className="ml-4">
                                    Enter the name and rank of the officer
                                    designated with responsibility for
                                    communications during an emergency
                                </li>
                                <li className="ml-4">
                                    Enter the name(s) of the person(s)
                                    designated with responsibility for carrying
                                    out the tests and checks of the equipment
                                    and log entries.
                                </li>
                            </ol>
                        </div>
                        <div className="mb-4">
                            <b>Part IV</b>
                            <p className="my-2">
                                This is the communication and test record
                                section.
                            </p>
                            <ol className="list-disc ml-4">
                                <li className="ml-4">
                                    Enter all communications, ensuring that each
                                    column is filled in accurately and
                                    correctly. Pay careful attention to any
                                    distress communications.
                                </li>
                                <li className="ml-4">
                                    Enter all daily, weekly and monthly tests as
                                    required below.
                                </li>
                            </ol>
                        </div>
                    </li>
                    <li className="mb-6">
                        <b className="uppercase text-lg">
                            EQUIPMENT AND ELECTRICAL POWER TESTS
                        </b>
                        <div className="mb-4 mt-2">
                            <b>Daily Tests</b>
                            <ol className="list-disc ml-4">
                                <li className="ml-4">
                                    Test of DSC equipment using the internal
                                    test facility without sending a signal.
                                </li>
                                <li className="ml-4">
                                    Self-test of Navtex, weather fax etc
                                </li>
                                <li className="ml-4">
                                    Check any batteries supplying power to any
                                    of the radio equipment and, where necessary,
                                    that they are fully charged.
                                </li>
                                <li className="ml-4">
                                    Check all paper rolls, where required, are
                                    fitted and that there are sufficient spare
                                    rolls for the intended voyage.
                                </li>
                            </ol>
                        </div>

                        <div className="mb-4">
                            <b>Weekly Tests</b>
                            <ol className="list-disc ml-4">
                                <li className="ml-4">
                                    Check proper operation of the DSC equipment
                                    by means of a test call when within
                                    communications range.
                                </li>
                                <li className="ml-4">
                                    Check the emergency power supply (battery
                                    and/or emergency generator).
                                </li>
                                <li className="ml-4">
                                    Check survival craft VHF, except where
                                    equipment is of a sealed type.
                                </li>
                            </ol>
                        </div>
                        <div className="mb-4">
                            <b>Monthly Tests</b>
                            <ol className="list-disc ml-4">
                                <li className="ml-4">
                                    Check each Search And Rescue Transponder
                                    (SART) and its mountings for security.
                                </li>
                                <li className="ml-4">
                                    Check each EPIRB for operation (in test mode
                                    only), its ability to float free (if
                                    required to do so), security of its mounting
                                    and for any signs of damage to the
                                    equipment.
                                </li>
                                <li className="ml-4">
                                    Full check of all batteries, including
                                    mountings and electrical connections, and
                                    check that the battery charger is operating
                                    correctly in all modes (where applicable).
                                </li>
                            </ol>
                        </div>
                    </li>
                </ol>
            </div>
            {/* Third page */}
            <div className="flex flex-col justify-between py-4 pt-0 px-16 mb-2 text-left">
                <h3 className="text-xl font-semibold print:mt-4">Part I</h3>
                <h4 className="uppercase text-lg font-medium py-4">
                    Details of ship
                </h4>
                <div className="flex flex-col">
                    <div className="flex items-center mb-2 text-base">
                        <p className="mr-2 min-w-fit mb-0">Name of ship:</p>
                        <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                            {nameOfShip}
                        </p>
                    </div>
                    <div className="flex w-full space-x-2 my-4">
                        <div className="basis-1/3 flex">
                            <p className="mr-2 min-w-fit mb-0">Call sign:</p>
                            <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                {callSign}
                            </p>
                        </div>
                        <div className="basis-1/3 flex">
                            <p className="mr-2 min-w-fit mb-0">MMSI:</p>
                            <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                {mmsi}
                            </p>
                        </div>
                        <div className="basis-1/3 flex">
                            <p className="mr-2 min-w-fit mb-0">
                                Port of Registry:
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                {portOfRegistry}
                            </p>
                        </div>
                    </div>
                    <div className="flex w-full space-x-2 my-4">
                        <div className="basis-1/3 flex">
                            <p className="mr-2 min-w-fit mb-0">IMO No.:</p>
                            <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                {imoNo}
                            </p>
                        </div>
                        <div className="basis-1/3 flex">
                            <p className="mr-2 min-w-fit mb-0">Official No.:</p>
                            <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                {officialNo}
                            </p>
                        </div>
                        <div className="basis-1/3 flex">
                            <p className="mr-2 min-w-fit mb-0">
                                Gross tonnage:
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                {grossTonnage}
                            </p>
                        </div>
                    </div>
                    <div className="flex space-x-2 my-4">
                        <div className="min-w-fit">
                            Sea Areas in which ship is certified to operate:
                        </div>
                        <div className="ml-4 w-full">
                            <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                {certifiedSeaAreas}
                            </p>
                        </div>
                    </div>
                    <div className="flex space-x-2 my-4">
                        <div className="min-w-fit">
                            Date of expiry of Safety Radio Certificate:
                        </div>
                        <div className="ml-4 w-full">
                            <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                {dateOfExpiryOfSafetyRadioCertificate}
                            </p>
                        </div>
                    </div>
                    <div className="my-4">
                        <p>
                            Method used to ensure availability of radio
                            facilities (tick box):
                        </p>
                        <div className="flex justify-center">
                            <div className="w-2/3 mt-4">
                                <table className="w-full border">
                                    <thead style={{ background: 'none' }}>
                                        <tr>
                                            <th
                                                className="p-2"
                                                style={{ width: 400 }}
                                            ></th>
                                            <th className="font-medium uppercase p-2">
                                                Yes
                                            </th>
                                            <th className="font-medium uppercase p-2">
                                                No
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border-none p-2">
                                                a&#x29; Duplication of equipment{' '}
                                            </td>
                                            <td className="border-none p-2">
                                                <div className="w-5 h-5 border text-gray-600 flex justify-center items-center">
                                                    {duplicationOfEquipment ? (
                                                        <span className="bp3-icon bp3-icon-tick text-sm text-gray-700" />
                                                    ) : null}
                                                </div>
                                            </td>
                                            <td className="border-none p-2">
                                                <div className="w-5 h-5 border text-gray-600 flex justify-center items-center">
                                                    {duplicationOfEquipment ? null : (
                                                        <span className="bp3-icon bp3-icon-tick text-sm text-gray-700" />
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="border-none p-2">
                                                b&#x29; Shore-based maintenance
                                                contract{' '}
                                            </td>
                                            <td className="border-none p-2">
                                                <div className="w-5 h-5 border text-gray-600 flex justify-center items-center">
                                                    {shoreBasedMaintenance ? (
                                                        <span className="bp3-icon bp3-icon-tick text-sm text-gray-700" />
                                                    ) : null}
                                                </div>
                                            </td>
                                            <td className="border-none p-2">
                                                <div className="w-5 h-5 border text-gray-600 flex justify-center items-center">
                                                    {shoreBasedMaintenance ? null : (
                                                        <span className="bp3-icon bp3-icon-tick text-sm text-gray-700" />
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {/* Fourth Page */}
                    <div className="my-4 px-16">
                        <p className="my-4">Details of service company:</p>
                        <div className="flex justify-center">
                            <div style={{ width: '80%' }}>
                                <div className="flex mb-2 items-center">
                                    <div style={{ width: 120 }}>Name:</div>
                                    <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                        {detailsOfServiceCompany?.name}
                                    </p>
                                </div>
                                <div className="flex mb-2 items-start">
                                    <div
                                        className="mt-2"
                                        style={{ width: 120 }}
                                    >
                                        Address:
                                    </div>
                                    <div className="w-full">
                                        <p
                                            style={{ paddingTop: '0.4rem' }}
                                            className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full self-end"
                                        >
                                            {detailsOfServiceCompany?.address}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-4">
                            <div className="flex justify-center">
                                <div className="w-2/3 mt-4">
                                    <table className="w-full border">
                                        <thead style={{ background: 'none' }}>
                                            <tr>
                                                <th
                                                    className="p-2"
                                                    style={{ width: 400 }}
                                                ></th>
                                                <th className="font-medium uppercase p-2">
                                                    Yes
                                                </th>
                                                <th className="font-medium uppercase p-2">
                                                    No
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="border-none p-2">
                                                    At sea maintenance
                                                    capability:
                                                </td>
                                                <td className="border-none p-2">
                                                    <div className="w-5 h-5 border text-gray-600 flex justify-center items-center">
                                                        {atSeaMaintenanceCapability ? (
                                                            <span className="bp3-icon bp3-icon-tick text-sm text-gray-700" />
                                                        ) : null}
                                                    </div>
                                                </td>
                                                <td className="border-none p-2">
                                                    <div className="w-5 h-5 border text-gray-600 flex justify-center items-center">
                                                        {atSeaMaintenanceCapability ? null : (
                                                            <span className="bp3-icon bp3-icon-tick text-sm text-gray-700" />
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="my-4">
                        <p className="my-4">
                            Name and Address of Owner, Managing Owner or Agent:
                        </p>
                        <div className="flex justify-center">
                            <div style={{ width: '80%' }}>
                                <div className="flex mb-2 items-center">
                                    <div style={{ width: 120 }}>Name:</div>
                                    <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                        {detailsOfOwnerCompany?.name}
                                    </p>
                                </div>
                                <div className="flex mb-2 items-start">
                                    <div
                                        className="mt-2"
                                        style={{ width: 120 }}
                                    >
                                        Address:
                                    </div>
                                    <div className="w-full">
                                        <p
                                            style={{ paddingTop: '0.4rem' }}
                                            className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full self-end"
                                        >
                                            {detailsOfOwnerCompany?.address}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Fifth page */}
            <div className="flex flex-col justify-between py-4 pt-0 px-16 mb-2">
                <h2 className="text-lg font-semibold my-4">Part 2</h2>
                <TKTable title={''} personnels={listOfPersonnels} />
            </div>
            {/* Sixth page */}
            <div className="flex flex-col justify-between py-4 pt-0 px-16 mb-2">
                <h2 className="text-lg font-semibold my-4">Part 3</h2>
                <div className="mb-8">
                    <TKTable
                        title={
                            'Name and Rank of designated person(s) with responsibility for Radio Communication during Emergencies:'
                        }
                        personnels={listOfPersonnels?.filter(
                            (personnel) => personnel.radio_comm_emergency
                        )}
                    />
                </div>
                {/* Seventh Page */}
                <div className="">
                    <div className="mt-4 print:mt-8">
                        <TKTable
                            title={
                                'Name of person (s) nominated to carry out appropriate tests, checks and Log entries(If different from above):'
                            }
                            personnels={listOfPersonnels?.filter(
                                (personnel) => personnel.radio_tests
                            )}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const inspectorStore = inspectorSelectors._getStore(store);
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);	
	const globalSettings = vesselSelectors.getGlobalSettings(vesselStore);
	const listOfPersonnels = commonUtils.objectToArray(
		vesselStore.logbookPersonnels
			? vesselStore.logbookPersonnels
			: { byIds: {}, ids: [] }
	);
	const dateRange = inspectorSelectors.getDateRange(inspectorStore);

    return {
        vesselInfo,
        globalSettings,
        listOfPersonnels,
        dateRange,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(GMDSSCoverPage);
